import Swiper, { Navigation, Keyboard, Pagination, EffectFade, Controller } from 'swiper';
import 'swiper/swiper-bundle.min.css';

export default () => {
  return {
      mounted() {

        
        const cardSlider = new Swiper('.block-slider', {
            modules: [Navigation, Keyboard],
            loop: true,
            slidesPerView: 1,
            watchSlidesProgress: true,
            spaceBetween: 20,
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            navigation: {
              nextEl: '.block-slider-next',
              prevEl: '.block-slider-prev'
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.25
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 40,
                },
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            }
        });

        
    }
  }
}